export const TEXT = {
  TITLE: {id: 'raf.referrals.hiw_header'},
  SUBTITLE: {id: 'raf.referrals.hiw_title'},
  STEP1: {id: 'raf.referrals.hiw_step1'},
  STEP2: {id: 'raf.referrals.hiw_step2'},
  STEP3: {id: 'raf.referrals.hiw_step3'},
  STEP4: {id: 'raf.referrals.hiw_step4'},
} as const;
